/** Tetto di `data_forni.descriz_art` (descrizione prodotto + nota). */
export const DESCRIZ_ART_MAX = 150;

/** Prefisso salvato in `descriz_art` davanti al testo della nota. */
export const NOTA_MARKER = "Nota: ";

const asText = (value) => String(value ?? "").trim();

/**
 * Caratteri occupati da " Nota: " (o solo "Nota: " se manca la descrizione).
 */
export function notaOverheadLength(descriz) {
  return asText(descriz) ? ` ${NOTA_MARKER}`.length : NOTA_MARKER.length;
}

/** Quanti caratteri restano per la nota, dato il testo prodotto. */
export function maxNotaLength(descriz) {
  return Math.max(0, DESCRIZ_ART_MAX - asText(descriz).length - notaOverheadLength(descriz));
}

/**
 * Spezza `descriz_art` in descrizione prodotto e nota.
 * Usa l'ultima occorrenza di `Nota: ` per non duplicare il marcatore al ricaricamento.
 */
export function splitDescrizAndNota(descrizArt) {
  const raw = asText(descrizArt);
  const idx = raw.lastIndexOf(NOTA_MARKER);
  if (idx === -1) {
    return { descriz: raw, nota: "" };
  }
  return {
    descriz: raw.slice(0, idx).trim(),
    nota: raw.slice(idx + NOTA_MARKER.length).trim(),
  };
}

/**
 * Compone la stringa da salvare in `descriz_art`.
 * Senza nota resta solo la descrizione; con nota: `{descrizione} Nota: {valore}`.
 */
export function composeDescrizArt(descriz, nota) {
  const base = asText(descriz).slice(0, DESCRIZ_ART_MAX);
  const note = asText(nota);
  if (!note) {
    return base;
  }
  const maxNote = maxNotaLength(base);
  if (maxNote <= 0) {
    return base;
  }
  const clipped = note.slice(0, maxNote);
  if (!base) {
    return `${NOTA_MARKER}${clipped}`.slice(0, DESCRIZ_ART_MAX);
  }
  return `${base} ${NOTA_MARKER}${clipped}`.slice(0, DESCRIZ_ART_MAX);
}

export function hasNota(order) {
  return asText(order?.nota) !== "";
}

export function ordineContieneTesto(order, testo) {
  const needle = asText(testo).toLowerCase();
  if (!needle) {
    return false;
  }
  const notaHay = hasNota(order) ? `${NOTA_MARKER}${order.nota}` : "";
  const hay = `${order?.descriz || ""} ${notaHay}`.toLowerCase();
  return hay.includes(needle);
}
